// Seed data: sample members for the public membership lookup.
// Only NON-SENSITIVE fields are modelled here on purpose:
// membership number, name, unit, status, joined year.

const FIRST = [
  "Anthony", "Maria", "Joseph", "Theresa", "Francis", "Agnes", "Savio", "Rita",
  "Melwyn", "Lourdes", "Clement", "Philomena", "Ryan", "Natasha", "Trevor",
  "Sandra", "Kevin", "Michelle", "Alban", "Gracy", "Wilfred", "Juliet",
  "Brian", "Cynthia", "Lloyd", "Veronica", "Errol", "Diana", "Neville", "Olga",
];

const LAST = [
  "D'Souza", "Fernandes", "Pereira", "Gonsalves", "Rodrigues", "D'Mello",
  "Lobo", "Pinto", "Noronha", "Sequeira", "Menezes", "Carvalho", "Dias",
  "Mascarenhas", "Almeida", "Coutinho", "Vaz", "Rebello", "Saldanha", "Misquitta",
];

const UNIT_SLUGS = [
  "st-peter-s-church", "mount-carmel-church", "st-andrew-s-church",
  "immaculate-conception-church", "our-lady-of-lourdes", "holy-cross-church",
  "st-michael-s-church", "sacred-heart-church", "st-blaise-church",
  "our-lady-of-perpetual-succour", "st-john-the-baptist-church", "gloria-church",
];

export const seedMembers = Array.from({ length: 64 }, (_, i) => {
  const first = FIRST[i % FIRST.length];
  const last = LAST[(i * 7) % LAST.length];
  const unit = UNIT_SLUGS[i % UNIT_SLUGS.length];
  return {
    id: `seed-mem-${i + 1}`,
    membership_no: `BCS-${String(10001 + i * 37)}`,
    full_name: `${first} ${last}`,
    unit_slug: unit,
    membership_type: i % 5 === 0 ? "Ordinary Member" : "Life Member",
    status: i % 11 === 0 ? "Lapsed" : "Active",
    joined_year: 1985 + ((i * 3) % 40),
  };
});
